import { Link } from "react-router-dom";

const ORDER = [
  { path: "/", label: "Home" },
  { path: "/features", label: "Features" },
  { path: "/pricing", label: "Pricing" },
  { path: "/contact", label: "Contact" },
  { path: "/press", label: "Press" },
];

const btn =
  "inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-white border border-[#166534] text-[#166534] text-sm font-medium transition-colors hover:bg-[#C4922A] hover:border-[#C4922A] hover:text-white";

export default function PageNav({ currentPath }: { currentPath: string }) {
  const idx = ORDER.findIndex((p) => p.path === currentPath);
  if (idx === -1) return null;
  const prev = idx > 0 ? ORDER[idx - 1] : null;
  const next = idx < ORDER.length - 1 ? ORDER[idx + 1] : null;

  return (
    <nav className="border-t border-border bg-background">
      <div className="container py-8 flex items-center justify-between gap-4">
        <div>
          {prev && (
            <Link to={prev.path} className={btn} aria-label={`Back to ${prev.label}`}>
              ← Back
            </Link>
          )}
        </div>
        <div>
          {next && (
            <Link to={next.path} className={btn} aria-label={`Next: ${next.label}`}>
              Next →
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
